export default "__VITE_ASSET__0100d048__"